(function () {
  try {
    if (typeof window === "undefined") return;
    if (window.__salepifyMofuCompatInstalled) return;
    window.__salepifyMofuCompatInstalled = true;

    try {
      var shop = (window.Shopify && window.Shopify.shop);
      var tokenKey = "salepify_store_access_token-" + shop;
      var badToken = localStorage.getItem(tokenKey);
      if (badToken && badToken.startsWith("c")) {
        localStorage.removeItem(tokenKey);
        localStorage.removeItem("salepify_store_access_token_cache_expires_at-" + shop);
      }
    } catch (e) {}

    function normalizeAddBody(body) {
      if (!body) return body;
      try {
        if (typeof body === "string" && (body.indexOf("items%5B0%5D") !== -1 || body.indexOf("items[0]") !== -1)) {
          var params = new URLSearchParams(body);
          var itemId = params.get("items[0][id]");
          if (itemId) {
            var quantity = params.get("items[0][quantity]") || "1";
            var sellingPlan = params.get("items[0][selling_plan]");
            params.delete("items[0][id]");
            params.delete("items[0][quantity]");
            if (sellingPlan) params.delete("items[0][selling_plan]");
            params.set("id", itemId);
            params.set("quantity", quantity);
            if (sellingPlan) params.set("selling_plan", sellingPlan);
            return params.toString();
          }
        } else if (window.FormData && body instanceof FormData) {
          var formItemId = body.get("items[0][id]");
          if (formItemId && !body.get("id")) {
            body.append("id", formItemId);
            var formQty = body.get("items[0][quantity]") || "1";
            if (!body.get("quantity")) body.append("quantity", formQty);
            var formSp = body.get("items[0][selling_plan]");
            if (formSp && !body.get("selling_plan")) body.append("selling_plan", formSp);
          }
        }
      } catch (e) {}
      return body;
    }

    try {
      var origToString = URLSearchParams.prototype.toString;
      URLSearchParams.prototype.toString = function () {
        var str = origToString.call(this);
        if (this.has("items[0][id]")) {
          var id = this.get("items[0][id]");
          var qty = this.get("items[0][quantity]") || "1";
          var sp = this.get("items[0][selling_plan]");
          var clone = new URLSearchParams(this);
          clone.delete("items[0][id]");
          clone.delete("items[0][quantity]");
          if (sp) clone.delete("items[0][selling_plan]");
          clone.set("id", id);
          clone.set("quantity", qty);
          if (sp) clone.set("selling_plan", sp);
          return origToString.call(clone);
        }
        return str;
      };
    } catch (e) {}

    function wrapFetch() {
      try {
        if (!window.fetch) return;
        var originalFetch = window.fetch;
        window.fetch = function (resource, config) {
          try {
            var url = typeof resource === "string" ? resource : (resource && resource.url) || "";
            if ((url.indexOf("/cart/add") !== -1 || url.indexOf("add.js") !== -1) && config && config.body) {
              config.body = normalizeAddBody(config.body);
            }
          } catch (e) {}
          return originalFetch.apply(this, arguments);
        };
      } catch (e) {}
    }

    wrapFetch();

    function refreshDrawerIfOpen() {
      try {
        var cartDrawer = document.getElementById("Cart-Drawer");
        if (!cartDrawer) return;
        var sectionId = cartDrawer.dataset ? cartDrawer.dataset.section : null;
        if (!sectionId) return;

        var joiner = window.location.search ? "&" : "?";
        var refreshUrl = window.location.pathname + window.location.search + joiner + "section_id=" + encodeURIComponent(sectionId);
        fetch(refreshUrl)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            try {
              var doc = new DOMParser().parseFromString(html, "text/html");
              var freshDetails = doc.getElementById("Cart-Drawer-Details");
              var currentDetails = document.getElementById("Cart-Drawer-Details");
              if (freshDetails && currentDetails) {
                currentDetails.innerHTML = freshDetails.innerHTML;
              }
            } catch (e) {}
          })
          .catch(function () {});
      } catch (e) {}
    }

    try {
      window.addEventListener("TLFREEGIFT:add", function () {
        setTimeout(refreshDrawerIfOpen, 300);
      });
    } catch (e) {}

  } catch (e) {}
})();
